module.exports = __webpack_public_path__ + "img/2_45.e96bc300.png";